import { Translate } from '@/components';
import { Button as MuiButton, ButtonProps } from '@mui/material';
import { css, cx } from '@emotion/css';
import { forwardRef } from 'react';

export type ButtonBaseProps = ButtonProps & {
  className?: string;
  children: React.ReactNode;
  fontColor?: string;
  background?: string;
  nonTranslate?: boolean;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
};

export const ButtonBase = forwardRef<HTMLButtonElement, ButtonBaseProps>(
  (
    {
      children,
      className,
      startAdornment,
      endAdornment,
      nonTranslate = false,
      ...rest
    }: ButtonBaseProps,
    ref
  ) => (
    <MuiButton
      ref={ref}
      className={cx(
        className,
        css`
          gap: 4px;
        `
      )}
      {...rest}
    >
      {startAdornment}
      {nonTranslate ? children : <Translate>{children}</Translate>}
      {endAdornment}
    </MuiButton>
  )
);
